/* eslint-disable camelcase */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

import { createAsyncAction } from 'Helpers/redux'
import { apiCall } from './api'

export const GET_PAYOUTS = createAsyncAction('GET_PAYOUTS')
export const getPayouts = () =>
  apiCall({
    method: 'get',
    endpoint: '/admin/payouts',
    types: GET_PAYOUTS,
  })

export const GET_AWAITING_PAYOUTS = createAsyncAction('GET_AWAITING_PAYOUTS')
export const getAwaitingPayouts = (page, search_string = '') =>
  apiCall({
    method: 'get',
    endpoint: `/admin/payouts/awaiting/${page}/?search_string=${search_string}`,
    types: GET_AWAITING_PAYOUTS,
  })

export const GET_PAID_PAYOUTS = createAsyncAction('GET_PAID_PAYOUTS')
export const getPaidPayouts = (page, search_string = '', orderBy = 'date') =>
  apiCall({
    method: 'get',
    endpoint: `/admin/payouts/paid/${page}/?search_string=${search_string}&orderBy=${orderBy}`,
    types: GET_PAID_PAYOUTS,
  })

export const PAYOUT_TO_CURATOR = createAsyncAction('PAYOUT_TO_CURATOR')
export const payoutToCurator = (curator_id, payout_id, callback) =>
  apiCall({
    method: 'post',
    endpoint: '/admin/payout',
    query: {
      curator_id,
      payout_id,
    },
    types: PAYOUT_TO_CURATOR,
    callback,
  })

export const SEND_RECIPIENT_CHECKING_NEEDED = createAsyncAction(
  'SEND_RECIPIENT_CHECKING_NEEDED'
)
export const sendRecipientCheckingNeeded = (curator_id, payout_id, callback) =>
  apiCall({
    method: 'post',
    endpoint: '/admin/send-recipient-checking-needed',
    query: {
      curator_id,
      payout_id,
    },
    types: SEND_RECIPIENT_CHECKING_NEEDED,
    callback,
  })

export const CANCEL_PAYOUT = createAsyncAction('CANCEL_PAYOUT')
export const cancelPayout = (payout_id, callback) =>
  apiCall({
    method: 'patch',
    endpoint: `/admin/cancel-payout`,
    query: {
      payout_id,
    },
    types: CANCEL_PAYOUT,
    callback,
  })
